<template>
    <div>
        <PageBanner :pageTitle="$t('sidebar_inonlays_title_one')" />

        <InOnLaysCare/>
    </div>
</template>

<script>
import InOnLaysCare from '../blog-details/InOnLaysCare.vue'
import PageBanner from '../Common/PageBanner'

export default {
    components: {
       PageBanner,
        InOnLaysCare ,
    }
}
</script>